import { styled as o } from "styled-components";
import { CommentOptions as t } from "../CommentOptions/index.js";
import { Caption as i } from "../../../../styles/typography/index.js";
import { Theme as r } from "../../../../styles/themes/index.js";
const a = o.div`
  display: flex;
  grid-area: content;
  align-items: flex-start;
`;
o(t)`
  margin-bottom: 0px;
`;
o.div`
  display: flex;
  align-items: center;
  color: rgb(${r.colors.Golf});

  span {
    ${i}
  }

  i {
    font-size: 14px;
    margin-right: 6px;
  }
`;
o.div``;
export {
  a as CommentContainer
};
